var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { PureComponent } from 'react';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import simpleAvatar from '../../assets/images/icons/avatar_user.svg';
import './card-avatar-with-two-subtitles.css';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
let CardAvatarWithTwoSubtitles = class CardAvatarWithTwoSubtitles extends PureComponent {
    static { this.propTypes = {
        image: string,
        subtitle1: string,
        subtitle2: string,
        title: string,
    }; }
    render() {
        const { image, title, subtitle1, subtitle2 } = this.props;
        return (React.createElement(Card, { uuid: generateUUID(), className: 'card-avatar-with-two-subtitles', selectionType: SelectionType.NONE, width: 12 },
            React.createElement("div", { className: 'card-awts-avatar' },
                React.createElement(Avatar, { image: image ? image : simpleAvatar })),
            React.createElement("div", { className: 'card-awts-content' },
                React.createElement("output", null, title),
                React.createElement("div", { className: 'card-awts-content-subtitles' },
                    React.createElement("output", null, subtitle1),
                    React.createElement("output", null, subtitle2)))));
    }
};
CardAvatarWithTwoSubtitles = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardAvatarWithTwoSubtitles);
export default CardAvatarWithTwoSubtitles;
//# sourceMappingURL=card-avatar-with-two-subtitles.js.map